module.exports = __webpack_public_path__ + "media/图1-26动画.6018f813.mp4";